import React from 'react';

function GreenBox() {
  const boxStyle = {
    backgroundColor: 'green',
    width: '100px',
    height: '50px',
  };

  return (
    <div style={boxStyle}></div>
  );
}

export default GreenBox;